// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueCarousel from "vue-carousel";
import babelPolyfill from "babel-polyfill";

import App from "./App";
import router from "./router";

Vue.use(VueCarousel);

Vue.config.productionTip = false;

new Vue({
  el: ".js-mapViewer",
  components: { App },
  router,
  template: "<app />",
});
